import { ColorScheme } from '@design/design-tokens/themes/theme-names';
import { mailTo } from '@helpers/utils/mail-to/mailTo';
import DarkLogo from '@static/images/brand/logo-dark.svg';
import LightLogo from '@static/images/brand/logo-light.svg';
import WebMaintenance from '@static/images/reflexivity/web-maintenance.svg';
import { useThemeStore } from '@terminal/components/theme-controller/stores/useThemeStore';
import { config } from '@terminal/config';
import { Trans, useTranslation } from 'react-i18next';

import styles from './Maintenance.module.scss';

export const Maintenance = () => {
  const { t } = useTranslation('common');
  const isDark = useThemeStore(state => state.colorScheme === ColorScheme.Dark);
  const supportEmail = mailTo(config.supportEmail);

  const ThemedLogo = isDark ? DarkLogo : LightLogo;

  return (
    <section className={styles.maintenanceRoot} data-testid="maintenance-mode">
      <aside className={styles.logo}>
        <ThemedLogo />
      </aside>
      <h1 className={styles.tagline}>
        <Trans
          t={t}
          i18nKey="common:maintenance.tagline"
          components={[<span className={styles.taglineAlt} key="" />]}
        />
      </h1>
      <section className={styles.description}>
        <p className={styles.textContent}>
          <Trans
            t={t}
            i18nKey="common:maintenance.textContent"
            components={[
              <a
                className={styles.styledAnchor}
                key="key-1"
                href={supportEmail}
              />,
            ]}
            values={{ email: config.supportEmail }}
          />
        </p>
        <aside className={styles.image}>
          <WebMaintenance />
        </aside>
      </section>
    </section>
  );
};
